import React from 'react';
import { Toaster } from 'sonner';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background paper-texture flex flex-col">
      <header className="border-b border-primary/20 bg-white/50 backdrop-blur-md sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-white font-serif font-bold">
              M
            </div>
            <h1 className="text-xl font-serif font-bold text-primary tracking-wide">Muthuswamy Deekshitar Workshop</h1>
          </div>
        </div>
      </header>
      
      <main className="flex-grow">
        {children}
      </main>
      
      <footer className="bg-[#2D2424] text-[#F5F2EB] py-8 mt-12">
        <div className="container mx-auto px-4 text-center">
          <p className="font-serif text-lg">Celebrating 250th Jayanthi Year</p>
          <p className="text-sm opacity-60 mt-2">© 2026 Carnatic Workshop. All rights reserved.</p>
        </div>
      </footer>
      <Toaster position="top-center" richColors />
    </div>
  );
};

export default Layout;
